<template>
  <Layout>
    <div class="filters_row">
      <div></div>
    </div>
    <div class="filters_devider"></div>

    <PageTitle />

    <div class="page-padding page-padding-all">
      <PaymentsChart />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'

import PageTitle from './PageTitle.vue'
import PaymentsChart from './PaymentsChart.vue'

export default {
  page: {
    title: 'График платежей',
  },
  components: {
    Layout,
    PageTitle,
    PaymentsChart,
  },
}
</script>
